
// ==========================================
// frontend/src/components/AboutInfo.jsx
import React from 'react';
import { FaAward, FaUsers, FaLightbulb, FaHandshake } from 'react-icons/fa';

const AboutInfo = () => {
  const features = [
    {
      icon: FaAward,
      title: 'Excellence',
      description: 'Des solutions de haute qualité adaptées à vos besoins'
    },
    {
      icon: FaUsers,
      title: 'Équipe Experte',
      description: 'Des professionnels qualifiés et passionnés'
    },
    {
      icon: FaLightbulb,
      title: 'Innovation',
      description: 'Technologies de pointe et solutions créatives'
    },
    {
      icon: FaHandshake,
      title: 'Partenariat',
      description: 'Une relation de confiance avec nos clients'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {features.map((feature, index) => (
        <div
          key={index}
          className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
        >
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-white">
            <feature.icon size={32} />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">{feature.title}</h3>
          <p className="text-gray-600">{feature.description}</p>
        </div>
      ))}
    </div>
  );
};

export default AboutInfo;

